import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEsc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEsc"><Path d="M12.5 1.5V1H11.5V1.5H12.5ZM11.5 5.5V6H12.5V5.5H11.5ZM11.5 1.5V5.5H12.5V1.5H11.5ZM21 12C21 16.9706 16.9706 21 12 21V22C17.5228 22 22 17.5228 22 12H21ZM12 21C7.02944 21 3 16.9706 3 12H2C2 17.5228 6.47715 22 12 22V21ZM3 12C3 8.76802 4.70327 5.93346 7.26353 4.34563L6.73647 3.4958C3.89449 5.25835 2 8.40773 2 12H3ZM16.7365 4.34563C19.2967 5.93346 21 8.76802 21 12H22C22 8.40773 20.1055 5.25835 17.2635 3.4958L16.7365 4.34563Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEsc;
